export default [
    {
        path: "/leave/sick-reports",
        component: () => import("../Components/List.vue"),
        name: "sick-report-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/sick-report/create",
        component: () => import("../Components/Create.vue"),
        name: "sick-report-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/sick-report/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "sick-report-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
